/**
 * Language utilities
 * Stores language preference in localStorage (like theme)
 */

export type Language = 'sv' | 'en';

const LANGUAGE_STORAGE_KEY = 'language';

/**
 * Get current language from localStorage
 * Fallback to 'sv' (Swedish)
 */
export const getLanguage = (): Language => {
  if (typeof window === 'undefined') return 'sv';
  const stored = localStorage.getItem(LANGUAGE_STORAGE_KEY) as Language | null;
  return stored === 'sv' || stored === 'en' ? stored : 'sv';
};

/**
 * Set language preference in localStorage
 * Dispatches custom event so LanguageContext can update
 */
export const setLanguage = (lang: Language): void => {
  if (typeof window === 'undefined') return;
  localStorage.setItem(LANGUAGE_STORAGE_KEY, lang);
  window.dispatchEvent(new CustomEvent('languagechange', { detail: lang }));
};



